import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Bell, X } from 'lucide-react';

const NotificationPrompt = () => {
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    // Check if the browser supports notifications
    if (!('Notification' in window)) {
      return;
    }

    // Only show if permission has not been asked yet ('default')
    if (Notification.permission === 'default') {
      // Delay showing it slightly to not bombard the user immediately on first paint
      const timer = setTimeout(() => {
        const hasDismissed = localStorage.getItem('notificationPromptDismissed');
        if (!hasDismissed) {
          setShowPrompt(true);
        }
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAllow = async () => {
    try {
      const permission = await Notification.requestPermission();
      if (permission === 'granted') {
        window.dispatchEvent(new Event('ezanNotificationsActivated'));
      }
      setShowPrompt(false);
    } catch (error) {
      console.error('Error requesting notification permission:', error);
      setShowPrompt(false);
    }
  };

  const handleDecline = () => {
    setShowPrompt(false);
    localStorage.setItem('notificationPromptDismissed', 'true');
  };

  if (!showPrompt) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.95 }}
        className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm"
      >
        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm overflow-hidden relative">
          <div className="p-6 text-center">
            <div className="w-16 h-16 bg-accent/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Bell className="w-8 h-8 text-accent animate-pulse" />
            </div>
            
            <h2 className="text-xl font-bold text-gray-900 mb-2">
              Lejo Njoftimet
            </h2>
            
            <p className="text-gray-600 mb-6 text-sm">
              Dëshironi të merrni njoftime për kohët e namazit dhe njoftime të rëndësishme nga Xhamia?
            </p>
            
            <div className="flex gap-3">
              <button
                onClick={handleDecline}
                className="flex-1 py-2.5 px-4 rounded-xl font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 transition-colors"
              >
                Më Vonë
              </button>
              <button
                onClick={handleAllow}
                className="flex-1 py-2.5 px-4 rounded-xl font-medium text-white bg-accent hover:bg-accent/90 transition-colors shadow-lg shadow-accent/20"
              >
                Lejo
              </button>
            </div>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default NotificationPrompt;
